<template>
  <div class="panel-progressbar">
    <div class="progressbar-title flex-row">
      <p class="title-text primary fw-500">Прогресс закрытия вакансии</p>
      <div class="title-counter flex-row">
        <Icon iconName="User-bold" iconColor="#0075DB" />
        <p class="text primary fw-500">{{ candidates }}/{{ maxCandidates }}</p>
      </div>
    </div>
    <Progress :percentage="progress" />
  </div>
</template>
<script>
import Progress from 'Elements/Progressbar/Progressbar';
import Icon from 'Elements/Icon/Icon';
export default {
  components: { Progress, Icon },
  props: {
    candidates: {
      type: String,
      default: '0'
    },
    maxCandidates: {
      type: String,
      default: '0'
    },
    progress: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style lang="scss" scoped>
.panel-progressbar {
  padding: 24px;
  border-bottom: 1px solid $black-20;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.progressbar-title {
  margin: 0 0 15px 0;
}

.title {
  &-text {
    color: $blue-100;
    font-size: 16px;
    line-height: 24px;
    margin: 0 16px 0 0;
    align-self: center;
    -ms-grid-row-align: center;
  }

  &-counter {
    .text {
      margin: 0;
    }

    .blue {
      color: $blue-120;
    }
  }
}
</style>
